import styled from 'styled-components'

export default styled.ul`
  height: 100%;
  margin: 0 40px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
